import React from 'react';
import PropTypes from 'prop-types';
import './UserContactCard.css';
import { hasContactInfo, getUserContactMethods } from '../../utils/contactUtils';

/**
 * A component to display a user's contact information in sidebars
 * Follows BEM naming convention for CSS classes
 */
const UserContactCard = ({ user }) => {
  // Only proceed if user has contact information
  if (!hasContactInfo(user)) {
    return null;
  }

  const contactMethods = getUserContactMethods(user);

  return (
    <div className="user-contact-card sidebar__section">
      <h4 className="user-contact-card__title sidebar__section-title">{user.name || user.username}'s Contact Information</h4>
      <div className="user-contact-card__list">
        {contactMethods.map(contact => (
          <div key={contact.platform} className="user-contact-card__item sidebar__stat">
            <span className="user-contact-card__label sidebar__stat-label">{contact.displayName}</span>
            <span className="user-contact-card__value sidebar__stat-value">
              {contact.url ? (
                <a 
                  href={contact.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {contact.value}
                </a>
              ) : (
                contact.value
              )}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

UserContactCard.propTypes = {
  user: PropTypes.shape({
    username: PropTypes.string.isRequired,
    name: PropTypes.string,
    contact: PropTypes.object
  }).isRequired
};

export default UserContactCard;